const tokens = {
  "colors.grey.50": {
    "value": "#FAFAFA",
    "variable": "var(--colors-grey-50)"
  },
  "colors.grey.100": {
    "value": "#F2F2F3",
    "variable": "var(--colors-grey-100)"
  },
  "colors.grey.200": {
    "value": "#E4E4E7",
    "variable": "var(--colors-grey-200)"
  },
  "colors.grey.300": {
    "value": "#C9C9CF",
    "variable": "var(--colors-grey-300)"
  },
  "colors.grey.400": {
    "value": "#AFAFB6",
    "variable": "var(--colors-grey-400)"
  },
  "colors.grey.500": {
    "value": "#94949E",
    "variable": "var(--colors-grey-500)"
  },
  "colors.grey.600": {
    "value": "#797986",
    "variable": "var(--colors-grey-600)"
  },
  "colors.grey.700": {
    "value": "#61616B",
    "variable": "var(--colors-grey-700)"
  },
  "colors.grey.800": {
    "value": "#494950",
    "variable": "var(--colors-grey-800)"
  },
  "colors.grey.900": {
    "value": "#303036",
    "variable": "var(--colors-grey-900)"
  },
  "colors.grey.950": {
    "value": "#18181B",
    "variable": "var(--colors-grey-950)"
  },
  "colors.blue.50": {
    "value": "#F1F9FD",
    "variable": "var(--colors-blue-50)"
  },
  "colors.blue.100": {
    "value": "#D1ECFA",
    "variable": "var(--colors-blue-100)"
  },
  "colors.blue.200": {
    "value": "#ACDFF6",
    "variable": "var(--colors-blue-200)"
  },
  "colors.blue.300": {
    "value": "#87D4F2",
    "variable": "var(--colors-blue-300)"
  },
  "colors.blue.400": {
    "value": "#6CCCEF",
    "variable": "var(--colors-blue-400)"
  },
  "colors.blue.500": {
    "value": "#40BDEB",
    "variable": "var(--colors-blue-500)"
  },
  "colors.blue.600": {
    "value": "#1E9CD2",
    "variable": "var(--colors-blue-600)"
  },
  "colors.blue.700": {
    "value": "#197AB2",
    "variable": "var(--colors-blue-700)"
  },
  "colors.blue.800": {
    "value": "#155784",
    "variable": "var(--colors-blue-800)"
  },
  "colors.blue.900": {
    "value": "#113F5F",
    "variable": "var(--colors-blue-900)"
  },
  "colors.blue.950": {
    "value": "#0B253D",
    "variable": "var(--colors-blue-950)"
  },
  "colors.purple.50": {
    "value": "#F9F6FE",
    "variable": "var(--colors-purple-50)"
  },
  "colors.purple.100": {
    "value": "#F2EBFC",
    "variable": "var(--colors-purple-100)"
  },
  "colors.purple.200": {
    "value": "#E7DAFA",
    "variable": "var(--colors-purple-200)"
  },
  "colors.purple.300": {
    "value": "#DDC7FA",
    "variable": "var(--colors-purple-300)"
  },
  "colors.purple.400": {
    "value": "#D2B4F8",
    "variable": "var(--colors-purple-400)"
  },
  "colors.purple.500": {
    "value": "#C8A4F7",
    "variable": "var(--colors-purple-500)"
  },
  "colors.purple.600": {
    "value": "#B586F3",
    "variable": "var(--colors-purple-600)"
  },
  "colors.purple.700": {
    "value": "#8B65DC",
    "variable": "var(--colors-purple-700)"
  },
  "colors.purple.800": {
    "value": "#823CC8",
    "variable": "var(--colors-purple-800)"
  },
  "colors.purple.900": {
    "value": "#5E1F9E",
    "variable": "var(--colors-purple-900)"
  },
  "colors.purple.950": {
    "value": "#40116F",
    "variable": "var(--colors-purple-950)"
  },
  "colors.purple.alpha.5": {
    "value": "rgba(45, 27, 98, 0.05)",
    "variable": "var(--colors-purple-alpha-5)"
  },
  "colors.purple.alpha.10": {
    "value": "rgba(45, 27, 98, 0.1)",
    "variable": "var(--colors-purple-alpha-10)"
  },
  "colors.purple.alpha.20": {
    "value": "rgba(45, 27, 98, 0.2)",
    "variable": "var(--colors-purple-alpha-20)"
  },
  "colors.purple.alpha.30": {
    "value": "rgba(45, 27, 98, 0.3)",
    "variable": "var(--colors-purple-alpha-30)"
  },
  "colors.purple.alpha.40": {
    "value": "rgba(45, 27, 98, 0.4)",
    "variable": "var(--colors-purple-alpha-40)"
  },
  "colors.purple.alpha.50": {
    "value": "rgba(45, 27, 98, 0.5)",
    "variable": "var(--colors-purple-alpha-50)"
  },
  "colors.purple.alpha.60": {
    "value": "rgba(45, 27, 98, 0.6)",
    "variable": "var(--colors-purple-alpha-60)"
  },
  "colors.purple.alpha.70": {
    "value": "rgba(45, 27, 98, 0.7)",
    "variable": "var(--colors-purple-alpha-70)"
  },
  "colors.purple.alpha.80": {
    "value": "rgba(45, 27, 98, 0.8)",
    "variable": "var(--colors-purple-alpha-80)"
  },
  "colors.purple.alpha.90": {
    "value": "rgba(45, 27, 98, 0.9)",
    "variable": "var(--colors-purple-alpha-90)"
  },
  "colors.lightYellow.50": {
    "value": "#FFFCF0",
    "variable": "var(--colors-light-yellow-50)"
  },
  "colors.lightYellow.100": {
    "value": "#FFF9DB",
    "variable": "var(--colors-light-yellow-100)"
  },
  "colors.lightYellow.200": {
    "value": "#FFF7CC",
    "variable": "var(--colors-light-yellow-200)"
  },
  "colors.lightYellow.300": {
    "value": "#FFF1A8",
    "variable": "var(--colors-light-yellow-300)"
  },
  "colors.lightYellow.400": {
    "value": "#FFED8F",
    "variable": "var(--colors-light-yellow-400)"
  },
  "colors.lightYellow.500": {
    "value": "#FFE767",
    "variable": "var(--colors-light-yellow-500)"
  },
  "colors.lightYellow.600": {
    "value": "#FFDD33",
    "variable": "var(--colors-light-yellow-600)"
  },
  "colors.lightYellow.700": {
    "value": "#FFCC00",
    "variable": "var(--colors-light-yellow-700)"
  },
  "colors.lightYellow.800": {
    "value": "#FFB700",
    "variable": "var(--colors-light-yellow-800)"
  },
  "colors.lightYellow.900": {
    "value": "#FAA700",
    "variable": "var(--colors-light-yellow-900)"
  },
  "colors.lightYellow.950": {
    "value": "#F08C00",
    "variable": "var(--colors-light-yellow-950)"
  },
  "colors.lightYellow.1000": {
    "value": "#CC8302",
    "variable": "var(--colors-light-yellow-1000)"
  },
  "colors.lightYellow.1100": {
    "value": "#A25C06",
    "variable": "var(--colors-light-yellow-1100)"
  },
  "colors.lightYellow.1200": {
    "value": "#86480D",
    "variable": "var(--colors-light-yellow-1200)"
  },
  "colors.lightYellow.1300": {
    "value": "#7A3701",
    "variable": "var(--colors-light-yellow-1300)"
  },
  "colors.lightYellow.1400": {
    "value": "#481A00",
    "variable": "var(--colors-light-yellow-1400)"
  },
  "colors.yellow.50": {
    "value": "#FFF9E5",
    "variable": "var(--colors-yellow-50)"
  },
  "colors.yellow.100": {
    "value": "#FCEBB1",
    "variable": "var(--colors-yellow-100)"
  },
  "colors.yellow.200": {
    "value": "#FFE285",
    "variable": "var(--colors-yellow-200)"
  },
  "colors.yellow.300": {
    "value": "#FFCE2E",
    "variable": "var(--colors-yellow-300)"
  },
  "colors.yellow.400": {
    "value": "#FFC300",
    "variable": "var(--colors-yellow-400)"
  },
  "colors.yellow.500": {
    "value": "#E5AF00",
    "variable": "var(--colors-yellow-500)"
  },
  "colors.yellow.600": {
    "value": "#BA8E00",
    "variable": "var(--colors-yellow-600)"
  },
  "colors.yellow.700": {
    "value": "#AD8500",
    "variable": "var(--colors-yellow-700)"
  },
  "colors.yellow.800": {
    "value": "#8F6D00",
    "variable": "var(--colors-yellow-800)"
  },
  "colors.yellow.900": {
    "value": "#6B5200",
    "variable": "var(--colors-yellow-900)"
  },
  "colors.yellow.950": {
    "value": "#523E00",
    "variable": "var(--colors-yellow-950)"
  },
  "colors.lightGreen.50": {
    "value": "#EDFDF2",
    "variable": "var(--colors-light-green-50)"
  },
  "colors.lightGreen.100": {
    "value": "#DAFBE5",
    "variable": "var(--colors-light-green-100)"
  },
  "colors.lightGreen.200": {
    "value": "#C3F8D5",
    "variable": "var(--colors-light-green-200)"
  },
  "colors.lightGreen.300": {
    "value": "#A7F6C1",
    "variable": "var(--colors-light-green-300)"
  },
  "colors.lightGreen.400": {
    "value": "#81F3A7",
    "variable": "var(--colors-light-green-400)"
  },
  "colors.lightGreen.500": {
    "value": "#63F293",
    "variable": "var(--colors-light-green-500)"
  },
  "colors.lightGreen.600": {
    "value": "#42D774",
    "variable": "var(--colors-light-green-600)"
  },
  "colors.lightGreen.700": {
    "value": "#2CAF58",
    "variable": "var(--colors-light-green-700)"
  },
  "colors.lightGreen.800": {
    "value": "#238042",
    "variable": "var(--colors-light-green-800)"
  },
  "colors.lightGreen.900": {
    "value": "#174F2A",
    "variable": "var(--colors-light-green-900)"
  },
  "colors.lightGreen.950": {
    "value": "#11361E",
    "variable": "var(--colors-light-green-950)"
  },
  "colors.green.50": {
    "value": "#F3FCF5",
    "variable": "var(--colors-green-50)"
  },
  "colors.green.100": {
    "value": "#CCF1D6",
    "variable": "var(--colors-green-100)"
  },
  "colors.green.200": {
    "value": "#99DEAD",
    "variable": "var(--colors-green-200)"
  },
  "colors.green.300": {
    "value": "#66C786",
    "variable": "var(--colors-green-300)"
  },
  "colors.green.400": {
    "value": "#33AA5F",
    "variable": "var(--colors-green-400)"
  },
  "colors.green.500": {
    "value": "#06893A",
    "variable": "var(--colors-green-500)"
  },
  "colors.green.600": {
    "value": "#007C2E",
    "variable": "var(--colors-green-600)"
  },
  "colors.green.700": {
    "value": "#006A23",
    "variable": "var(--colors-green-700)"
  },
  "colors.green.800": {
    "value": "#005519",
    "variable": "var(--colors-green-800)"
  },
  "colors.green.900": {
    "value": "#003B0F",
    "variable": "var(--colors-green-900)"
  },
  "colors.green.950": {
    "value": "#002108",
    "variable": "var(--colors-green-950)"
  },
  "colors.pink.50": {
    "value": "#FEF2F3",
    "variable": "var(--colors-pink-50)"
  },
  "colors.pink.100": {
    "value": "#FDECEF",
    "variable": "var(--colors-pink-100)"
  },
  "colors.pink.200": {
    "value": "#FCDEE3",
    "variable": "var(--colors-pink-200)"
  },
  "colors.pink.300": {
    "value": "#F9C3CE",
    "variable": "var(--colors-pink-300)"
  },
  "colors.pink.400": {
    "value": "#F79CAE",
    "variable": "var(--colors-pink-400)"
  },
  "colors.pink.500": {
    "value": "#F67992",
    "variable": "var(--colors-pink-500)"
  },
  "colors.pink.600": {
    "value": "#EF4D6D",
    "variable": "var(--colors-pink-600)"
  },
  "colors.pink.700": {
    "value": "#D53457",
    "variable": "var(--colors-pink-700)"
  },
  "colors.pink.800": {
    "value": "#A82447",
    "variable": "var(--colors-pink-800)"
  },
  "colors.pink.900": {
    "value": "#761935",
    "variable": "var(--colors-pink-900)"
  },
  "colors.pink.950": {
    "value": "#4A1124",
    "variable": "var(--colors-pink-950)"
  },
  "colors.red.50": {
    "value": "#FFE6E6",
    "variable": "var(--colors-red-50)"
  },
  "colors.red.100": {
    "value": "#FFC2C2",
    "variable": "var(--colors-red-100)"
  },
  "colors.red.200": {
    "value": "#F68282",
    "variable": "var(--colors-red-200)"
  },
  "colors.red.300": {
    "value": "#F25C5C",
    "variable": "var(--colors-red-300)"
  },
  "colors.red.400": {
    "value": "#DE2E2E",
    "variable": "var(--colors-red-400)"
  },
  "colors.red.500": {
    "value": "#C30000",
    "variable": "var(--colors-red-500)"
  },
  "colors.red.600": {
    "value": "#AD0000",
    "variable": "var(--colors-red-600)"
  },
  "colors.red.700": {
    "value": "#8C0000",
    "variable": "var(--colors-red-700)"
  },
  "colors.red.800": {
    "value": "#5C0000",
    "variable": "var(--colors-red-800)"
  },
  "colors.red.900": {
    "value": "#260000",
    "variable": "var(--colors-red-900)"
  },
  "colors.red.950": {
    "value": "#1A0000",
    "variable": "var(--colors-red-950)"
  },
  "colors.white": {
    "value": "#FFFFFF",
    "variable": "var(--colors-white)"
  },
  "colors.primary": {
    "value": "#2D1B62",
    "variable": "var(--colors-primary)"
  },
  "easings.default": {
    "value": "cubic-bezier(0.17, 0.04, 0.03, 0.94)",
    "variable": "var(--easings-default)"
  },
  "easings.emphasized-in": {
    "value": "cubic-bezier(0.05, 0.7, 0.1, 1.0)",
    "variable": "var(--easings-emphasized-in)"
  },
  "easings.emphasized-out": {
    "value": "cubic-bezier(0.3, 0.0, 0.8, 0.15)",
    "variable": "var(--easings-emphasized-out)"
  },
  "easings.pulse": {
    "value": "cubic-bezier(0.4, 0.0, 0.6, 1.0)",
    "variable": "var(--easings-pulse)"
  },
  "durations.superFast": {
    "value": "100ms",
    "variable": "var(--durations-super-fast)"
  },
  "durations.fast": {
    "value": "200ms",
    "variable": "var(--durations-fast)"
  },
  "durations.normal": {
    "value": "400ms",
    "variable": "var(--durations-normal)"
  },
  "durations.slow": {
    "value": "600ms",
    "variable": "var(--durations-slow)"
  },
  "durations.infinite": {
    "value": "infinite",
    "variable": "var(--durations-infinite)"
  },
  "radii.sharp": {
    "value": "0px",
    "variable": "var(--radii-sharp)"
  },
  "radii.xsmall": {
    "value": "var(--spacing-4xsmall)",
    "variable": "var(--radii-xsmall)"
  },
  "radii.small": {
    "value": "var(--spacing-xxsmall)",
    "variable": "var(--radii-small)"
  },
  "radii.medium": {
    "value": "var(--spacing-xsmall)",
    "variable": "var(--radii-medium)"
  },
  "radii.large": {
    "value": "var(--spacing-medium)",
    "variable": "var(--radii-large)"
  },
  "radii.full": {
    "value": "100%",
    "variable": "var(--radii-full)"
  },
  "spacing.1": {
    "value": "2px",
    "variable": "var(--spacing-1)"
  },
  "spacing.2": {
    "value": "4px",
    "variable": "var(--spacing-2)"
  },
  "spacing.3": {
    "value": "6px",
    "variable": "var(--spacing-3)"
  },
  "spacing.4": {
    "value": "8px",
    "variable": "var(--spacing-4)"
  },
  "spacing.5": {
    "value": "10px",
    "variable": "var(--spacing-5)"
  },
  "spacing.6": {
    "value": "12px",
    "variable": "var(--spacing-6)"
  },
  "spacing.7": {
    "value": "14px",
    "variable": "var(--spacing-7)"
  },
  "spacing.8": {
    "value": "16px",
    "variable": "var(--spacing-8)"
  },
  "spacing.9": {
    "value": "18px",
    "variable": "var(--spacing-9)"
  },
  "spacing.10": {
    "value": "20px",
    "variable": "var(--spacing-10)"
  },
  "spacing.11": {
    "value": "22px",
    "variable": "var(--spacing-11)"
  },
  "spacing.12": {
    "value": "24px",
    "variable": "var(--spacing-12)"
  },
  "spacing.13": {
    "value": "26px",
    "variable": "var(--spacing-13)"
  },
  "spacing.14": {
    "value": "28px",
    "variable": "var(--spacing-14)"
  },
  "spacing.15": {
    "value": "30px",
    "variable": "var(--spacing-15)"
  },
  "spacing.16": {
    "value": "32px",
    "variable": "var(--spacing-16)"
  },
  "spacing.17": {
    "value": "34px",
    "variable": "var(--spacing-17)"
  },
  "spacing.18": {
    "value": "36px",
    "variable": "var(--spacing-18)"
  },
  "spacing.19": {
    "value": "38px",
    "variable": "var(--spacing-19)"
  },
  "spacing.20": {
    "value": "40px",
    "variable": "var(--spacing-20)"
  },
  "spacing.22": {
    "value": "44px",
    "variable": "var(--spacing-22)"
  },
  "spacing.24": {
    "value": "48px",
    "variable": "var(--spacing-24)"
  },
  "spacing.26": {
    "value": "52px",
    "variable": "var(--spacing-26)"
  },
  "spacing.28": {
    "value": "56px",
    "variable": "var(--spacing-28)"
  },
  "spacing.32": {
    "value": "64px",
    "variable": "var(--spacing-32)"
  },
  "spacing.36": {
    "value": "72px",
    "variable": "var(--spacing-36)"
  },
  "spacing.40": {
    "value": "80px",
    "variable": "var(--spacing-40)"
  },
  "spacing.44": {
    "value": "88px",
    "variable": "var(--spacing-44)"
  },
  "spacing.48": {
    "value": "96px",
    "variable": "var(--spacing-48)"
  },
  "spacing.50": {
    "value": "100px",
    "variable": "var(--spacing-50)"
  },
  "spacing.60": {
    "value": "120px",
    "variable": "var(--spacing-60)"
  },
  "spacing.72": {
    "value": "144px",
    "variable": "var(--spacing-72)"
  },
  "spacing.75": {
    "value": "150px",
    "variable": "var(--spacing-75)"
  },
  "spacing.100": {
    "value": "200px",
    "variable": "var(--spacing-100)"
  },
  "spacing.150": {
    "value": "300px",
    "variable": "var(--spacing-150)"
  },
  "spacing.200": {
    "value": "400px",
    "variable": "var(--spacing-200)"
  },
  "spacing.250": {
    "value": "500px",
    "variable": "var(--spacing-250)"
  },
  "spacing.300": {
    "value": "600px",
    "variable": "var(--spacing-300)"
  },
  "spacing.350": {
    "value": "700px",
    "variable": "var(--spacing-350)"
  },
  "spacing.400": {
    "value": "800px",
    "variable": "var(--spacing-400)"
  },
  "spacing.500": {
    "value": "1000px",
    "variable": "var(--spacing-500)"
  },
  "spacing.550": {
    "value": "1100px",
    "variable": "var(--spacing-550)"
  },
  "sizes.1": {
    "value": "2px",
    "variable": "var(--sizes-1)"
  },
  "sizes.2": {
    "value": "4px",
    "variable": "var(--sizes-2)"
  },
  "sizes.3": {
    "value": "6px",
    "variable": "var(--sizes-3)"
  },
  "sizes.4": {
    "value": "8px",
    "variable": "var(--sizes-4)"
  },
  "sizes.5": {
    "value": "10px",
    "variable": "var(--sizes-5)"
  },
  "sizes.6": {
    "value": "12px",
    "variable": "var(--sizes-6)"
  },
  "sizes.7": {
    "value": "14px",
    "variable": "var(--sizes-7)"
  },
  "sizes.8": {
    "value": "16px",
    "variable": "var(--sizes-8)"
  },
  "sizes.9": {
    "value": "18px",
    "variable": "var(--sizes-9)"
  },
  "sizes.10": {
    "value": "20px",
    "variable": "var(--sizes-10)"
  },
  "sizes.11": {
    "value": "22px",
    "variable": "var(--sizes-11)"
  },
  "sizes.12": {
    "value": "24px",
    "variable": "var(--sizes-12)"
  },
  "sizes.13": {
    "value": "26px",
    "variable": "var(--sizes-13)"
  },
  "sizes.14": {
    "value": "28px",
    "variable": "var(--sizes-14)"
  },
  "sizes.15": {
    "value": "30px",
    "variable": "var(--sizes-15)"
  },
  "sizes.16": {
    "value": "32px",
    "variable": "var(--sizes-16)"
  },
  "sizes.17": {
    "value": "34px",
    "variable": "var(--sizes-17)"
  },
  "sizes.18": {
    "value": "36px",
    "variable": "var(--sizes-18)"
  },
  "sizes.19": {
    "value": "38px",
    "variable": "var(--sizes-19)"
  },
  "sizes.20": {
    "value": "40px",
    "variable": "var(--sizes-20)"
  },
  "sizes.22": {
    "value": "44px",
    "variable": "var(--sizes-22)"
  },
  "sizes.24": {
    "value": "48px",
    "variable": "var(--sizes-24)"
  },
  "sizes.26": {
    "value": "52px",
    "variable": "var(--sizes-26)"
  },
  "sizes.28": {
    "value": "56px",
    "variable": "var(--sizes-28)"
  },
  "sizes.32": {
    "value": "64px",
    "variable": "var(--sizes-32)"
  },
  "sizes.36": {
    "value": "72px",
    "variable": "var(--sizes-36)"
  },
  "sizes.40": {
    "value": "80px",
    "variable": "var(--sizes-40)"
  },
  "sizes.44": {
    "value": "88px",
    "variable": "var(--sizes-44)"
  },
  "sizes.48": {
    "value": "96px",
    "variable": "var(--sizes-48)"
  },
  "sizes.50": {
    "value": "100px",
    "variable": "var(--sizes-50)"
  },
  "sizes.60": {
    "value": "120px",
    "variable": "var(--sizes-60)"
  },
  "sizes.72": {
    "value": "144px",
    "variable": "var(--sizes-72)"
  },
  "sizes.75": {
    "value": "150px",
    "variable": "var(--sizes-75)"
  },
  "sizes.100": {
    "value": "200px",
    "variable": "var(--sizes-100)"
  },
  "sizes.150": {
    "value": "300px",
    "variable": "var(--sizes-150)"
  },
  "sizes.200": {
    "value": "400px",
    "variable": "var(--sizes-200)"
  },
  "sizes.250": {
    "value": "500px",
    "variable": "var(--sizes-250)"
  },
  "sizes.300": {
    "value": "600px",
    "variable": "var(--sizes-300)"
  },
  "sizes.350": {
    "value": "700px",
    "variable": "var(--sizes-350)"
  },
  "sizes.400": {
    "value": "800px",
    "variable": "var(--sizes-400)"
  },
  "sizes.500": {
    "value": "1000px",
    "variable": "var(--sizes-500)"
  },
  "sizes.550": {
    "value": "1100px",
    "variable": "var(--sizes-550)"
  },
  "sizes.breakpoint-mobile": {
    "value": "20em",
    "variable": "var(--sizes-breakpoint-mobile)"
  },
  "sizes.breakpoint-mobileWide": {
    "value": "29.75em",
    "variable": "var(--sizes-breakpoint-mobile-wide)"
  },
  "sizes.breakpoint-tablet": {
    "value": "37.5625em",
    "variable": "var(--sizes-breakpoint-tablet)"
  },
  "sizes.breakpoint-tabletWide": {
    "value": "48em",
    "variable": "var(--sizes-breakpoint-tablet-wide)"
  },
  "sizes.breakpoint-desktop": {
    "value": "61.3125em",
    "variable": "var(--sizes-breakpoint-desktop)"
  },
  "sizes.breakpoint-wide": {
    "value": "81.3125em",
    "variable": "var(--sizes-breakpoint-wide)"
  },
  "sizes.breakpoint-ultraWide": {
    "value": "100.0625em",
    "variable": "var(--sizes-breakpoint-ultra-wide)"
  },
  "lineHeights.xxsmall": {
    "value": "0.75rem",
    "variable": "var(--line-heights-xxsmall)"
  },
  "lineHeights.xsmall": {
    "value": "1.375rem",
    "variable": "var(--line-heights-xsmall)"
  },
  "lineHeights.small": {
    "value": "1.5rem",
    "variable": "var(--line-heights-small)"
  },
  "lineHeights.medium": {
    "value": "1.75rem",
    "variable": "var(--line-heights-medium)"
  },
  "lineHeights.large": {
    "value": "1.875rem",
    "variable": "var(--line-heights-large)"
  },
  "lineHeights.xlarge": {
    "value": "2.25rem",
    "variable": "var(--line-heights-xlarge)"
  },
  "lineHeights.xxlarge": {
    "value": "2.375rem",
    "variable": "var(--line-heights-xxlarge)"
  },
  "lineHeights.3xlarge": {
    "value": "3rem",
    "variable": "var(--line-heights-3xlarge)"
  },
  "lineHeights.4xlarge": {
    "value": "3.75rem",
    "variable": "var(--line-heights-4xlarge)"
  },
  "fontWeights.light": {
    "value": 300,
    "variable": "var(--font-weights-light)"
  },
  "fontWeights.normal": {
    "value": 400,
    "variable": "var(--font-weights-normal)"
  },
  "fontWeights.semibold": {
    "value": 600,
    "variable": "var(--font-weights-semibold)"
  },
  "fontWeights.bold": {
    "value": 670,
    "variable": "var(--font-weights-bold)"
  },
  "fontSizes.xxsmall": {
    "value": "0.75rem",
    "variable": "var(--font-sizes-xxsmall)"
  },
  "fontSizes.xsmall": {
    "value": "0.875rem",
    "variable": "var(--font-sizes-xsmall)"
  },
  "fontSizes.small": {
    "value": "1rem",
    "variable": "var(--font-sizes-small)"
  },
  "fontSizes.medium": {
    "value": "1.125rem",
    "variable": "var(--font-sizes-medium)"
  },
  "fontSizes.large": {
    "value": "1.375rem",
    "variable": "var(--font-sizes-large)"
  },
  "fontSizes.xlarge": {
    "value": "1.625rem",
    "variable": "var(--font-sizes-xlarge)"
  },
  "fontSizes.xxlarge": {
    "value": "1.875rem",
    "variable": "var(--font-sizes-xxlarge)"
  },
  "fontSizes.3xlarge": {
    "value": "2.375rem",
    "variable": "var(--font-sizes-3xlarge)"
  },
  "fontSizes.4xlarge": {
    "value": "3rem",
    "variable": "var(--font-sizes-4xlarge)"
  },
  "fonts.sans": {
    "value": "Satoshi, Helvetica, Arial, STKaiti, '华文楷体', KaiTi, SimKai, '楷体', KaiU, DFKai-SB, '標楷體', SongTi, '宋体', sans-serif",
    "variable": "var(--fonts-sans)"
  },
  "fonts.serif": {
    "value": "'Source Serif 4 Variable', Times, STKaiti, '华文楷体', KaiTi, SimKai, '楷体', KaiU, DFKai-SB, '標楷體', SongTi, '宋体', serif",
    "variable": "var(--fonts-serif)"
  },
  "fonts.code": {
    "value": "'Source Code Pro Variable', Monaco",
    "variable": "var(--fonts-code)"
  },
  "animations.rainbow-spin": {
    "value": "rainbow-spin 2000ms cubic-bezier(.175, .885, .32, 1.275) infinite",
    "variable": "var(--animations-rainbow-spin)"
  },
  "animations.spin": {
    "value": "spin 700ms infinite linear",
    "variable": "var(--animations-spin)"
  },
  "animations.collapse-in": {
    "value": "collapse-in 250ms var(--easings-emphasized-in)",
    "variable": "var(--animations-collapse-in)"
  },
  "animations.collapse-out": {
    "value": "collapse-out 200ms var(--easings-emphasized-out)",
    "variable": "var(--animations-collapse-out)"
  },
  "animations.fade-shift-in": {
    "value": "fade-shift-in 200ms var(--easings-emphasized-in)",
    "variable": "var(--animations-fade-shift-in)"
  },
  "animations.fade-shift-out": {
    "value": "fade-shift-in 200ms var(--easings-emphasized-in)",
    "variable": "var(--animations-fade-shift-out)"
  },
  "animations.backdrop-in": {
    "value": "fade-in 250ms var(--easings-emphasized-in)",
    "variable": "var(--animations-backdrop-in)"
  },
  "animations.backdrop-out": {
    "value": "fade-out 200ms var(--easings-emphasized-out)",
    "variable": "var(--animations-backdrop-out)"
  },
  "animations.dialog-in": {
    "value": "fade-in 400ms var(--easings-emphasized-in)",
    "variable": "var(--animations-dialog-in)"
  },
  "animations.dialog-out": {
    "value": "fade-out 200ms var(--easings-emphasized-out)",
    "variable": "var(--animations-dialog-out)"
  },
  "animations.drawer-in-left": {
    "value": "slide-in-left 400ms var(--easings-emphasized-in)",
    "variable": "var(--animations-drawer-in-left)"
  },
  "animations.drawer-out-left": {
    "value": "slide-out-left 200ms var(--easings-emphasized-out)",
    "variable": "var(--animations-drawer-out-left)"
  },
  "animations.drawer-in-right": {
    "value": "slide-in-right 400ms var(--easings-emphasized-in)",
    "variable": "var(--animations-drawer-in-right)"
  },
  "animations.drawer-out-right": {
    "value": "slide-out-right 200ms var(--easings-emphasized-out)",
    "variable": "var(--animations-drawer-out-right)"
  },
  "animations.drawer-in-bottom": {
    "value": "slide-in-bottom 400ms var(--easings-emphasized-in)",
    "variable": "var(--animations-drawer-in-bottom)"
  },
  "animations.drawer-out-bottom": {
    "value": "slide-out-bottom 200ms var(--easings-emphasized-out)",
    "variable": "var(--animations-drawer-out-bottom)"
  },
  "animations.drawer-in-top": {
    "value": "slide-in-top 400ms var(--easings-emphasized-in)",
    "variable": "var(--animations-drawer-in-top)"
  },
  "animations.drawer-out-top": {
    "value": "slide-out-top 200ms var(--easings-emphasized-out)",
    "variable": "var(--animations-drawer-out-top)"
  },
  "animations.skeleton-pulse": {
    "value": "skeleton-pulse 2s var(--easings-pulse) infinite",
    "variable": "var(--animations-skeleton-pulse)"
  },
  "shadows.xsmall": {
    "value": "0px 1px 4px 0px rgba(0, 0, 0, 0.15), 0px 0px 1px 0px rgba(0, 0, 0, 0.18)",
    "variable": "var(--shadows-xsmall)"
  },
  "shadows.small": {
    "value": "0px 3px 8px 0px rgba(0, 0, 0, 0.1), 0px 1px 3px 0px rgba(0, 0, 0, 0.1), 0px 0px 1px 0px rgba(0, 0, 0, 0.18)",
    "variable": "var(--shadows-small)"
  },
  "shadows.medium": {
    "value": "0px 5px 12px 0px rgba(0, 0, 0, 0.13), 0px 1px 3px 0px rgba(0, 0, 0, 0.1), 0px 0px 1px 0px rgba(0, 0, 0, 0.15)",
    "variable": "var(--shadows-medium)"
  },
  "shadows.large": {
    "value": "0px 10px 16px 0px rgba(0, 0, 0, 0.12), 0px 2px 5px 0px rgba(0, 0, 0, 0.15), 0px 0px 1px 0px rgba(0, 0, 0, 0.12)",
    "variable": "var(--shadows-large)"
  },
  "shadows.xlarge": {
    "value": "0px 10px 24px 0px rgba(0, 0, 0, 0.18), 0px 2px 5px 0px rgba(0, 0, 0, 0.15), 0px 0px 1px 0px rgba(0, 0, 0, 0.08)",
    "variable": "var(--shadows-xlarge)"
  },
  "shadows.full": {
    "value": "4px 4px 0px 0px var(--colors-primary)",
    "variable": "var(--shadows-full)"
  },
  "shadows.inner": {
    "value": "0px -1px 0px 0px rgba(45, 27, 98, 0.25) inset",
    "variable": "var(--shadows-inner)"
  },
  "shadows.innerTop": {
    "value": "0px 1px 0px 0px rgba(45, 27, 98, 0.25) inset",
    "variable": "var(--shadows-inner-top)"
  },
  "shadows.innerRight": {
    "value": "-1px 0px 0px 0px rgba(45, 27, 98, 0.25) inset",
    "variable": "var(--shadows-inner-right)"
  },
  "zIndex.hide": {
    "value": -1,
    "variable": "var(--z-index-hide)"
  },
  "zIndex.base": {
    "value": 0,
    "variable": "var(--z-index-base)"
  },
  "zIndex.docked": {
    "value": 10,
    "variable": "var(--z-index-docked)"
  },
  "zIndex.dropdown": {
    "value": 1000,
    "variable": "var(--z-index-dropdown)"
  },
  "zIndex.sticky": {
    "value": 1100,
    "variable": "var(--z-index-sticky)"
  },
  "zIndex.banner": {
    "value": 1200,
    "variable": "var(--z-index-banner)"
  },
  "zIndex.overlay": {
    "value": 1300,
    "variable": "var(--z-index-overlay)"
  },
  "zIndex.modal": {
    "value": 1400,
    "variable": "var(--z-index-modal)"
  },
  "zIndex.alertModalOverlay": {
    "value": 1500,
    "variable": "var(--z-index-alert-modal-overlay)"
  },
  "zIndex.alertModal": {
    "value": 1600,
    "variable": "var(--z-index-alert-modal)"
  },
  "zIndex.popover": {
    "value": 1700,
    "variable": "var(--z-index-popover)"
  },
  "zIndex.skipLink": {
    "value": 1800,
    "variable": "var(--z-index-skip-link)"
  },
  "zIndex.toast": {
    "value": 1900,
    "variable": "var(--z-index-toast)"
  },
  "zIndex.tooltip": {
    "value": 2000,
    "variable": "var(--z-index-tooltip)"
  },
  "breakpoints.mobile": {
    "value": "20em",
    "variable": "var(--breakpoints-mobile)"
  },
  "breakpoints.mobileWide": {
    "value": "29.75em",
    "variable": "var(--breakpoints-mobile-wide)"
  },
  "breakpoints.tablet": {
    "value": "37.5625em",
    "variable": "var(--breakpoints-tablet)"
  },
  "breakpoints.tabletWide": {
    "value": "48em",
    "variable": "var(--breakpoints-tablet-wide)"
  },
  "breakpoints.desktop": {
    "value": "61.3125em",
    "variable": "var(--breakpoints-desktop)"
  },
  "breakpoints.wide": {
    "value": "81.3125em",
    "variable": "var(--breakpoints-wide)"
  },
  "breakpoints.ultraWide": {
    "value": "100.0625em",
    "variable": "var(--breakpoints-ultra-wide)"
  },
  "spacing.5xsmall": {
    "value": "var(--spacing-1)",
    "variable": "var(--spacing-5xsmall)"
  },
  "spacing.4xsmall": {
    "value": "var(--spacing-2)",
    "variable": "var(--spacing-4xsmall)"
  },
  "spacing.3xsmall": {
    "value": "var(--spacing-3)",
    "variable": "var(--spacing-3xsmall)"
  },
  "spacing.xxsmall": {
    "value": "var(--spacing-4)",
    "variable": "var(--spacing-xxsmall)"
  },
  "spacing.xsmall": {
    "value": "var(--spacing-6)",
    "variable": "var(--spacing-xsmall)"
  },
  "spacing.small": {
    "value": "var(--spacing-8)",
    "variable": "var(--spacing-small)"
  },
  "spacing.medium": {
    "value": "var(--spacing-12)",
    "variable": "var(--spacing-medium)"
  },
  "spacing.large": {
    "value": "var(--spacing-16)",
    "variable": "var(--spacing-large)"
  },
  "spacing.xlarge": {
    "value": "var(--spacing-18)",
    "variable": "var(--spacing-xlarge)"
  },
  "spacing.xxlarge": {
    "value": "var(--spacing-24)",
    "variable": "var(--spacing-xxlarge)"
  },
  "spacing.3xlarge": {
    "value": "var(--spacing-36)",
    "variable": "var(--spacing-3xlarge)"
  },
  "spacing.4xlarge": {
    "value": "var(--spacing-48)",
    "variable": "var(--spacing-4xlarge)"
  },
  "spacing.5xlarge": {
    "value": "var(--spacing-60)",
    "variable": "var(--spacing-5xlarge)"
  },
  "spacing.surface.4xsmall": {
    "value": "var(--spacing-50)",
    "variable": "var(--spacing-surface-4xsmall)"
  },
  "spacing.surface.3xsmall": {
    "value": "var(--spacing-75)",
    "variable": "var(--spacing-surface-3xsmall)"
  },
  "spacing.surface.xxsmall": {
    "value": "var(--spacing-100)",
    "variable": "var(--spacing-surface-xxsmall)"
  },
  "spacing.surface.xsmall": {
    "value": "var(--spacing-150)",
    "variable": "var(--spacing-surface-xsmall)"
  },
  "spacing.surface.small": {
    "value": "var(--spacing-200)",
    "variable": "var(--spacing-surface-small)"
  },
  "spacing.surface.medium": {
    "value": "var(--spacing-250)",
    "variable": "var(--spacing-surface-medium)"
  },
  "spacing.surface.large": {
    "value": "var(--spacing-300)",
    "variable": "var(--spacing-surface-large)"
  },
  "spacing.surface.xlarge": {
    "value": "var(--spacing-350)",
    "variable": "var(--spacing-surface-xlarge)"
  },
  "spacing.surface.xxlarge": {
    "value": "var(--spacing-400)",
    "variable": "var(--spacing-surface-xxlarge)"
  },
  "spacing.surface.3xlarge": {
    "value": "var(--spacing-500)",
    "variable": "var(--spacing-surface-3xlarge)"
  },
  "spacing.surface.4xlarge": {
    "value": "var(--spacing-550)",
    "variable": "var(--spacing-surface-4xlarge)"
  },
  "sizes.5xsmall": {
    "value": "var(--spacing-1)",
    "variable": "var(--sizes-5xsmall)"
  },
  "sizes.4xsmall": {
    "value": "var(--spacing-2)",
    "variable": "var(--sizes-4xsmall)"
  },
  "sizes.3xsmall": {
    "value": "var(--spacing-3)",
    "variable": "var(--sizes-3xsmall)"
  },
  "sizes.xxsmall": {
    "value": "var(--spacing-4)",
    "variable": "var(--sizes-xxsmall)"
  },
  "sizes.xsmall": {
    "value": "var(--spacing-6)",
    "variable": "var(--sizes-xsmall)"
  },
  "sizes.small": {
    "value": "var(--spacing-8)",
    "variable": "var(--sizes-small)"
  },
  "sizes.medium": {
    "value": "var(--spacing-12)",
    "variable": "var(--sizes-medium)"
  },
  "sizes.large": {
    "value": "var(--spacing-16)",
    "variable": "var(--sizes-large)"
  },
  "sizes.xlarge": {
    "value": "var(--spacing-18)",
    "variable": "var(--sizes-xlarge)"
  },
  "sizes.xxlarge": {
    "value": "var(--spacing-24)",
    "variable": "var(--sizes-xxlarge)"
  },
  "sizes.3xlarge": {
    "value": "var(--spacing-36)",
    "variable": "var(--sizes-3xlarge)"
  },
  "sizes.4xlarge": {
    "value": "var(--spacing-48)",
    "variable": "var(--sizes-4xlarge)"
  },
  "sizes.5xlarge": {
    "value": "var(--spacing-60)",
    "variable": "var(--sizes-5xlarge)"
  },
  "sizes.surface.4xsmall": {
    "value": "var(--spacing-50)",
    "variable": "var(--sizes-surface-4xsmall)"
  },
  "sizes.surface.3xsmall": {
    "value": "var(--spacing-75)",
    "variable": "var(--sizes-surface-3xsmall)"
  },
  "sizes.surface.xxsmall": {
    "value": "var(--spacing-100)",
    "variable": "var(--sizes-surface-xxsmall)"
  },
  "sizes.surface.xsmall": {
    "value": "var(--spacing-150)",
    "variable": "var(--sizes-surface-xsmall)"
  },
  "sizes.surface.small": {
    "value": "var(--spacing-200)",
    "variable": "var(--sizes-surface-small)"
  },
  "sizes.surface.medium": {
    "value": "var(--spacing-250)",
    "variable": "var(--sizes-surface-medium)"
  },
  "sizes.surface.large": {
    "value": "var(--spacing-300)",
    "variable": "var(--sizes-surface-large)"
  },
  "sizes.surface.xlarge": {
    "value": "var(--spacing-350)",
    "variable": "var(--sizes-surface-xlarge)"
  },
  "sizes.surface.xxlarge": {
    "value": "var(--spacing-400)",
    "variable": "var(--sizes-surface-xxlarge)"
  },
  "sizes.surface.3xlarge": {
    "value": "var(--spacing-500)",
    "variable": "var(--sizes-surface-3xlarge)"
  },
  "sizes.surface.4xlarge": {
    "value": "var(--spacing-550)",
    "variable": "var(--sizes-surface-4xlarge)"
  },
  "sizes.surface.pageMax": {
    "value": "1128px",
    "variable": "var(--sizes-surface-page-max)"
  },
  "sizes.surface.contentMax": {
    "value": "744px",
    "variable": "var(--sizes-surface-content-max)"
  },
  "sizes.surface.articleMax": {
    "value": "928px",
    "variable": "var(--sizes-surface-article-max)"
  },
  "sizes.surface.wideMax": {
    "value": "1440px",
    "variable": "var(--sizes-surface-wide-max)"
  },
  "colors.background.default": {
    "value": "var(--colors-white)",
    "variable": "var(--colors-background-default)"
  },
  "colors.background.subtle": {
    "value": "var(--colors-grey-100)",
    "variable": "var(--colors-background-subtle)"
  },
  "colors.background.strong": {
    "value": "var(--colors-purple-50)",
    "variable": "var(--colors-background-strong)"
  },
  "colors.text.default": {
    "value": "var(--colors-grey-950)",
    "variable": "var(--colors-text-default)"
  },
  "colors.text.subtle": {
    "value": "var(--colors-grey-700)",
    "variable": "var(--colors-text-subtle)"
  },
  "colors.text.strong": {
    "value": "var(--colors-primary)",
    "variable": "var(--colors-text-strong)"
  },
  "colors.text.action": {
    "value": "var(--colors-purple-800)",
    "variable": "var(--colors-text-action)"
  },
  "colors.text.onAction": {
    "value": "var(--colors-white)",
    "variable": "var(--colors-text-on-action)"
  },
  "colors.text.link": {
    "value": "var(--colors-blue-800)",
    "variable": "var(--colors-text-link)"
  },
  "colors.text.linkVisited": {
    "value": "var(--colors-purple-900)",
    "variable": "var(--colors-text-link-visited)"
  },
  "colors.text.error": {
    "value": "var(--colors-red-600)",
    "variable": "var(--colors-text-error)"
  },
  "colors.text.disabled": {
    "value": "var(--colors-grey-400)",
    "variable": "var(--colors-text-disabled)"
  },
  "colors.icon.default": {
    "value": "var(--colors-grey-950)",
    "variable": "var(--colors-icon-default)"
  },
  "colors.icon.strong": {
    "value": "var(--colors-primary)",
    "variable": "var(--colors-icon-strong)"
  },
  "colors.icon.onAction": {
    "value": "var(--colors-white)",
    "variable": "var(--colors-icon-on-action)"
  },
  "colors.icon.subtle": {
    "value": "var(--colors-grey-700)",
    "variable": "var(--colors-icon-subtle)"
  },
  "colors.icon.warning": {
    "value": "var(--colors-yellow-600)",
    "variable": "var(--colors-icon-warning)"
  },
  "colors.icon.danger": {
    "value": "var(--colors-red-500)",
    "variable": "var(--colors-icon-danger)"
  },
  "colors.surface.brand.1": {
    "value": "var(--colors-purple-500)",
    "variable": "var(--colors-surface-brand-1)"
  },
  "colors.surface.brand.1.subtle": {
    "value": "var(--colors-purple-100)",
    "variable": "var(--colors-surface-brand-1-subtle)"
  },
  "colors.surface.brand.1.moderate": {
    "value": "var(--colors-purple-300)",
    "variable": "var(--colors-surface-brand-1-moderate)"
  },
  "colors.surface.brand.1.strong": {
    "value": "var(--colors-purple-950)",
    "variable": "var(--colors-surface-brand-1-strong)"
  },
  "colors.surface.brand.2": {
    "value": "var(--colors-blue-500)",
    "variable": "var(--colors-surface-brand-2)"
  },
  "colors.surface.brand.2.subtle": {
    "value": "var(--colors-blue-50)",
    "variable": "var(--colors-surface-brand-2-subtle)"
  },
  "colors.surface.brand.2.moderate": {
    "value": "var(--colors-blue-100)",
    "variable": "var(--colors-surface-brand-2-moderate)"
  },
  "colors.surface.brand.2.bold": {
    "value": "var(--colors-blue-800)",
    "variable": "var(--colors-surface-brand-2-bold)"
  },
  "colors.surface.brand.2.strong": {
    "value": "var(--colors-blue-900)",
    "variable": "var(--colors-surface-brand-2-strong)"
  },
  "colors.surface.brand.3": {
    "value": "var(--colors-light-green-500)",
    "variable": "var(--colors-surface-brand-3)"
  },
  "colors.surface.brand.3.subtle": {
    "value": "var(--colors-light-green-100)",
    "variable": "var(--colors-surface-brand-3-subtle)"
  },
  "colors.surface.brand.3.moderate": {
    "value": "var(--colors-light-green-300)",
    "variable": "var(--colors-surface-brand-3-moderate)"
  },
  "colors.surface.brand.3.strong": {
    "value": "var(--colors-light-green-900)",
    "variable": "var(--colors-surface-brand-3-strong)"
  },
  "colors.surface.brand.4": {
    "value": "var(--colors-light-yellow-500)",
    "variable": "var(--colors-surface-brand-4)"
  },
  "colors.surface.brand.4.subtle": {
    "value": "var(--colors-light-yellow-100)",
    "variable": "var(--colors-surface-brand-4-subtle)"
  },
  "colors.surface.brand.4.moderate": {
    "value": "var(--colors-light-yellow-300)",
    "variable": "var(--colors-surface-brand-4-moderate)"
  },
  "colors.surface.brand.4.strong": {
    "value": "var(--colors-light-yellow-1100)",
    "variable": "var(--colors-surface-brand-4-strong)"
  },
  "colors.surface.brand.5": {
    "value": "var(--colors-pink-500)",
    "variable": "var(--colors-surface-brand-5)"
  },
  "colors.surface.brand.5.subtle": {
    "value": "var(--colors-pink-100)",
    "variable": "var(--colors-surface-brand-5-subtle)"
  },
  "colors.surface.brand.5.moderate": {
    "value": "var(--colors-pink-300)",
    "variable": "var(--colors-surface-brand-5-moderate)"
  },
  "colors.surface.brand.5.strong": {
    "value": "var(--colors-pink-900)",
    "variable": "var(--colors-surface-brand-5-strong)"
  },
  "colors.surface.default": {
    "value": "var(--colors-white)",
    "variable": "var(--colors-surface-default)"
  },
  "colors.surface.hover": {
    "value": "var(--colors-purple-alpha-5)",
    "variable": "var(--colors-surface-hover)"
  },
  "colors.surface.active": {
    "value": "var(--colors-purple-alpha-10)",
    "variable": "var(--colors-surface-active)"
  },
  "colors.surface.selected": {
    "value": "var(--colors-purple-200)",
    "variable": "var(--colors-surface-selected)"
  },
  "colors.surface.disabled": {
    "value": "var(--colors-grey-200)",
    "variable": "var(--colors-surface-disabled)"
  },
  "colors.surface.disabled.subtle": {
    "value": "var(--colors-grey-50)",
    "variable": "var(--colors-surface-disabled-subtle)"
  },
  "colors.surface.disabled.strong": {
    "value": "var(--colors-grey-700)",
    "variable": "var(--colors-surface-disabled-strong)"
  },
  "colors.surface.infoSubtle": {
    "value": "var(--colors-grey-100)",
    "variable": "var(--colors-surface-info-subtle)"
  },
  "colors.surface.infoSubtle.hover": {
    "value": "var(--colors-grey-200)",
    "variable": "var(--colors-surface-info-subtle-hover)"
  },
  "colors.surface.infoSubtle.active": {
    "value": "var(--colors-grey-300)",
    "variable": "var(--colors-surface-info-subtle-active)"
  },
  "colors.surface.action": {
    "value": "var(--colors-primary)",
    "variable": "var(--colors-surface-action)"
  },
  "colors.surface.action.hover": {
    "value": "var(--colors-purple-900)",
    "variable": "var(--colors-surface-action-hover)"
  },
  "colors.surface.action.active": {
    "value": "var(--colors-purple-950)",
    "variable": "var(--colors-surface-action-active)"
  },
  "colors.surface.action.selected": {
    "value": "var(--colors-purple-800)",
    "variable": "var(--colors-surface-action-selected)"
  },
  "colors.surface.action.myNdla": {
    "value": "var(--colors-light-yellow-300)",
    "variable": "var(--colors-surface-action-my-ndla)"
  },
  "colors.surface.action.myNdla.hover": {
    "value": "var(--colors-light-yellow-500)",
    "variable": "var(--colors-surface-action-my-ndla-hover)"
  },
  "colors.surface.action.myNdla.current": {
    "value": "var(--colors-light-yellow-700)",
    "variable": "var(--colors-surface-action-my-ndla-current)"
  },
  "colors.surface.action.brand.1": {
    "value": "var(--colors-purple-50)",
    "variable": "var(--colors-surface-action-brand-1)"
  },
  "colors.surface.action.brand.1.hover": {
    "value": "var(--colors-purple-100)",
    "variable": "var(--colors-surface-action-brand-1-hover)"
  },
  "colors.surface.action.brand.1.hover.strong": {
    "value": "var(--colors-purple-400)",
    "variable": "var(--colors-surface-action-brand-1-hover-strong)"
  },
  "colors.surface.action.brand.1.active": {
    "value": "var(--colors-purple-300)",
    "variable": "var(--colors-surface-action-brand-1-active)"
  },
  "colors.surface.action.brand.1.selected": {
    "value": "var(--colors-purple-400)",
    "variable": "var(--colors-surface-action-brand-1-selected)"
  },
  "colors.surface.action.brand.2": {
    "value": "var(--colors-blue-50)",
    "variable": "var(--colors-surface-action-brand-2)"
  },
  "colors.surface.action.brand.2.hover": {
    "value": "var(--colors-blue-100)",
    "variable": "var(--colors-surface-action-brand-2-hover)"
  },
  "colors.surface.action.brand.2.selected": {
    "value": "var(--colors-blue-200)",
    "variable": "var(--colors-surface-action-brand-2-selected)"
  },
  "colors.surface.actionSubtle": {
    "value": "var(--colors-purple-50)",
    "variable": "var(--colors-surface-action-subtle)"
  },
  "colors.surface.actionSubtle.hover": {
    "value": "var(--colors-purple-100)",
    "variable": "var(--colors-surface-action-subtle-hover)"
  },
  "colors.surface.actionSubtle.hover.strong": {
    "value": "var(--colors-purple-400)",
    "variable": "var(--colors-surface-action-subtle-hover-strong)"
  },
  "colors.surface.actionSubtle.active": {
    "value": "var(--colors-purple-300)",
    "variable": "var(--colors-surface-action-subtle-active)"
  },
  "colors.surface.actionSubtle.selected": {
    "value": "var(--colors-purple-900)",
    "variable": "var(--colors-surface-action-subtle-selected)"
  },
  "colors.surface.success": {
    "value": "var(--colors-green-500)",
    "variable": "var(--colors-surface-success)"
  },
  "colors.surface.success.hover": {
    "value": "var(--colors-green-700)",
    "variable": "var(--colors-surface-success-hover)"
  },
  "colors.surface.success.selected": {
    "value": "var(--colors-green-900)",
    "variable": "var(--colors-surface-success-selected)"
  },
  "colors.surface.success.active": {
    "value": "var(--colors-green-700)",
    "variable": "var(--colors-surface-success-active)"
  },
  "colors.surface.successSubtle": {
    "value": "var(--colors-green-50)",
    "variable": "var(--colors-surface-success-subtle)"
  },
  "colors.surface.successSubtle.hover": {
    "value": "var(--colors-green-100)",
    "variable": "var(--colors-surface-success-subtle-hover)"
  },
  "colors.surface.successSubtle.active": {
    "value": "var(--colors-green-300)",
    "variable": "var(--colors-surface-success-subtle-active)"
  },
  "colors.surface.warning": {
    "value": "var(--colors-yellow-400)",
    "variable": "var(--colors-surface-warning)"
  },
  "colors.surface.warning.hover": {
    "value": "var(--colors-yellow-500)",
    "variable": "var(--colors-surface-warning-hover)"
  },
  "colors.surface.warning.active": {
    "value": "var(--colors-yellow-700)",
    "variable": "var(--colors-surface-warning-active)"
  },
  "colors.surface.warningSubtle": {
    "value": "var(--colors-yellow-50)",
    "variable": "var(--colors-surface-warning-subtle)"
  },
  "colors.surface.warningSubtle.hover": {
    "value": "var(--colors-yellow-100)",
    "variable": "var(--colors-surface-warning-subtle-hover)"
  },
  "colors.surface.warningSubtle.active": {
    "value": "var(--colors-yellow-200)",
    "variable": "var(--colors-surface-warning-subtle-active)"
  },
  "colors.surface.danger": {
    "value": "var(--colors-red-500)",
    "variable": "var(--colors-surface-danger)"
  },
  "colors.surface.danger.hover": {
    "value": "var(--colors-red-700)",
    "variable": "var(--colors-surface-danger-hover)"
  },
  "colors.surface.danger.selected": {
    "value": "var(--colors-red-800)",
    "variable": "var(--colors-surface-danger-selected)"
  },
  "colors.surface.danger.active": {
    "value": "var(--colors-red-900)",
    "variable": "var(--colors-surface-danger-active)"
  },
  "colors.surface.dangerSubtle": {
    "value": "var(--colors-red-50)",
    "variable": "var(--colors-surface-danger-subtle)"
  },
  "colors.surface.dangerSubtle.hover": {
    "value": "var(--colors-red-100)",
    "variable": "var(--colors-surface-danger-subtle-hover)"
  },
  "colors.surface.dangerSubtle.active": {
    "value": "var(--colors-red-200)",
    "variable": "var(--colors-surface-danger-subtle-active)"
  },
  "colors.surface.error": {
    "value": "var(--colors-pink-500)",
    "variable": "var(--colors-surface-error)"
  },
  "colors.surface.error.hover": {
    "value": "var(--colors-pink-700)",
    "variable": "var(--colors-surface-error-hover)"
  },
  "colors.surface.error.active": {
    "value": "var(--colors-pink-900)",
    "variable": "var(--colors-surface-error-active)"
  },
  "colors.surface.errorSubtle": {
    "value": "var(--colors-red-50)",
    "variable": "var(--colors-surface-error-subtle)"
  },
  "colors.surface.errorSubtle.hover": {
    "value": "var(--colors-pink-100)",
    "variable": "var(--colors-surface-error-subtle-hover)"
  },
  "colors.surface.errorSubtle.active": {
    "value": "var(--colors-pink-200)",
    "variable": "var(--colors-surface-error-subtle-active)"
  },
  "colors.surface.subtle": {
    "value": "var(--colors-grey-50)",
    "variable": "var(--colors-surface-subtle)"
  },
  "colors.surface.subtle.selected": {
    "value": "var(--colors-grey-100)",
    "variable": "var(--colors-surface-subtle-selected)"
  },
  "colors.stroke.default": {
    "value": "var(--colors-primary)",
    "variable": "var(--colors-stroke-default)"
  },
  "colors.stroke.hover": {
    "value": "var(--colors-purple-800)",
    "variable": "var(--colors-stroke-hover)"
  },
  "colors.stroke.subtle": {
    "value": "var(--colors-grey-500)",
    "variable": "var(--colors-stroke-subtle)"
  },
  "colors.stroke.success": {
    "value": "var(--colors-light-green-900)",
    "variable": "var(--colors-stroke-success)"
  },
  "colors.stroke.info": {
    "value": "var(--colors-grey-500)",
    "variable": "var(--colors-stroke-info)"
  },
  "colors.stroke.warning": {
    "value": "var(--colors-yellow-600)",
    "variable": "var(--colors-stroke-warning)"
  },
  "colors.stroke.error": {
    "value": "var(--colors-red-600)",
    "variable": "var(--colors-stroke-error)"
  },
  "colors.stroke.disabled": {
    "value": "var(--colors-grey-300)",
    "variable": "var(--colors-stroke-disabled)"
  },
  "colors.stroke.discrete": {
    "value": "var(--colors-grey-300)",
    "variable": "var(--colors-stroke-discrete)"
  },
  "spacing.-1": {
    "value": "calc(var(--spacing-1) * -1)",
    "variable": "var(--spacing-1)"
  },
  "spacing.-2": {
    "value": "calc(var(--spacing-2) * -1)",
    "variable": "var(--spacing-2)"
  },
  "spacing.-3": {
    "value": "calc(var(--spacing-3) * -1)",
    "variable": "var(--spacing-3)"
  },
  "spacing.-4": {
    "value": "calc(var(--spacing-4) * -1)",
    "variable": "var(--spacing-4)"
  },
  "spacing.-5": {
    "value": "calc(var(--spacing-5) * -1)",
    "variable": "var(--spacing-5)"
  },
  "spacing.-6": {
    "value": "calc(var(--spacing-6) * -1)",
    "variable": "var(--spacing-6)"
  },
  "spacing.-7": {
    "value": "calc(var(--spacing-7) * -1)",
    "variable": "var(--spacing-7)"
  },
  "spacing.-8": {
    "value": "calc(var(--spacing-8) * -1)",
    "variable": "var(--spacing-8)"
  },
  "spacing.-9": {
    "value": "calc(var(--spacing-9) * -1)",
    "variable": "var(--spacing-9)"
  },
  "spacing.-10": {
    "value": "calc(var(--spacing-10) * -1)",
    "variable": "var(--spacing-10)"
  },
  "spacing.-11": {
    "value": "calc(var(--spacing-11) * -1)",
    "variable": "var(--spacing-11)"
  },
  "spacing.-12": {
    "value": "calc(var(--spacing-12) * -1)",
    "variable": "var(--spacing-12)"
  },
  "spacing.-13": {
    "value": "calc(var(--spacing-13) * -1)",
    "variable": "var(--spacing-13)"
  },
  "spacing.-14": {
    "value": "calc(var(--spacing-14) * -1)",
    "variable": "var(--spacing-14)"
  },
  "spacing.-15": {
    "value": "calc(var(--spacing-15) * -1)",
    "variable": "var(--spacing-15)"
  },
  "spacing.-16": {
    "value": "calc(var(--spacing-16) * -1)",
    "variable": "var(--spacing-16)"
  },
  "spacing.-17": {
    "value": "calc(var(--spacing-17) * -1)",
    "variable": "var(--spacing-17)"
  },
  "spacing.-18": {
    "value": "calc(var(--spacing-18) * -1)",
    "variable": "var(--spacing-18)"
  },
  "spacing.-19": {
    "value": "calc(var(--spacing-19) * -1)",
    "variable": "var(--spacing-19)"
  },
  "spacing.-20": {
    "value": "calc(var(--spacing-20) * -1)",
    "variable": "var(--spacing-20)"
  },
  "spacing.-22": {
    "value": "calc(var(--spacing-22) * -1)",
    "variable": "var(--spacing-22)"
  },
  "spacing.-24": {
    "value": "calc(var(--spacing-24) * -1)",
    "variable": "var(--spacing-24)"
  },
  "spacing.-26": {
    "value": "calc(var(--spacing-26) * -1)",
    "variable": "var(--spacing-26)"
  },
  "spacing.-28": {
    "value": "calc(var(--spacing-28) * -1)",
    "variable": "var(--spacing-28)"
  },
  "spacing.-32": {
    "value": "calc(var(--spacing-32) * -1)",
    "variable": "var(--spacing-32)"
  },
  "spacing.-36": {
    "value": "calc(var(--spacing-36) * -1)",
    "variable": "var(--spacing-36)"
  },
  "spacing.-40": {
    "value": "calc(var(--spacing-40) * -1)",
    "variable": "var(--spacing-40)"
  },
  "spacing.-44": {
    "value": "calc(var(--spacing-44) * -1)",
    "variable": "var(--spacing-44)"
  },
  "spacing.-48": {
    "value": "calc(var(--spacing-48) * -1)",
    "variable": "var(--spacing-48)"
  },
  "spacing.-50": {
    "value": "calc(var(--spacing-50) * -1)",
    "variable": "var(--spacing-50)"
  },
  "spacing.-60": {
    "value": "calc(var(--spacing-60) * -1)",
    "variable": "var(--spacing-60)"
  },
  "spacing.-72": {
    "value": "calc(var(--spacing-72) * -1)",
    "variable": "var(--spacing-72)"
  },
  "spacing.-75": {
    "value": "calc(var(--spacing-75) * -1)",
    "variable": "var(--spacing-75)"
  },
  "spacing.-100": {
    "value": "calc(var(--spacing-100) * -1)",
    "variable": "var(--spacing-100)"
  },
  "spacing.-150": {
    "value": "calc(var(--spacing-150) * -1)",
    "variable": "var(--spacing-150)"
  },
  "spacing.-200": {
    "value": "calc(var(--spacing-200) * -1)",
    "variable": "var(--spacing-200)"
  },
  "spacing.-250": {
    "value": "calc(var(--spacing-250) * -1)",
    "variable": "var(--spacing-250)"
  },
  "spacing.-300": {
    "value": "calc(var(--spacing-300) * -1)",
    "variable": "var(--spacing-300)"
  },
  "spacing.-350": {
    "value": "calc(var(--spacing-350) * -1)",
    "variable": "var(--spacing-350)"
  },
  "spacing.-400": {
    "value": "calc(var(--spacing-400) * -1)",
    "variable": "var(--spacing-400)"
  },
  "spacing.-500": {
    "value": "calc(var(--spacing-500) * -1)",
    "variable": "var(--spacing-500)"
  },
  "spacing.-550": {
    "value": "calc(var(--spacing-550) * -1)",
    "variable": "var(--spacing-550)"
  },
  "spacing.-5xsmall": {
    "value": "calc(var(--spacing-5xsmall) * -1)",
    "variable": "var(--spacing-5xsmall)"
  },
  "spacing.-4xsmall": {
    "value": "calc(var(--spacing-4xsmall) * -1)",
    "variable": "var(--spacing-4xsmall)"
  },
  "spacing.-3xsmall": {
    "value": "calc(var(--spacing-3xsmall) * -1)",
    "variable": "var(--spacing-3xsmall)"
  },
  "spacing.-xxsmall": {
    "value": "calc(var(--spacing-xxsmall) * -1)",
    "variable": "var(--spacing-xxsmall)"
  },
  "spacing.-xsmall": {
    "value": "calc(var(--spacing-xsmall) * -1)",
    "variable": "var(--spacing-xsmall)"
  },
  "spacing.-small": {
    "value": "calc(var(--spacing-small) * -1)",
    "variable": "var(--spacing-small)"
  },
  "spacing.-medium": {
    "value": "calc(var(--spacing-medium) * -1)",
    "variable": "var(--spacing-medium)"
  },
  "spacing.-large": {
    "value": "calc(var(--spacing-large) * -1)",
    "variable": "var(--spacing-large)"
  },
  "spacing.-xlarge": {
    "value": "calc(var(--spacing-xlarge) * -1)",
    "variable": "var(--spacing-xlarge)"
  },
  "spacing.-xxlarge": {
    "value": "calc(var(--spacing-xxlarge) * -1)",
    "variable": "var(--spacing-xxlarge)"
  },
  "spacing.-3xlarge": {
    "value": "calc(var(--spacing-3xlarge) * -1)",
    "variable": "var(--spacing-3xlarge)"
  },
  "spacing.-4xlarge": {
    "value": "calc(var(--spacing-4xlarge) * -1)",
    "variable": "var(--spacing-4xlarge)"
  },
  "spacing.-5xlarge": {
    "value": "calc(var(--spacing-5xlarge) * -1)",
    "variable": "var(--spacing-5xlarge)"
  },
  "spacing.surface.-4xsmall": {
    "value": "calc(var(--spacing-surface-4xsmall) * -1)",
    "variable": "var(--spacing-surface-4xsmall)"
  },
  "spacing.surface.-3xsmall": {
    "value": "calc(var(--spacing-surface-3xsmall) * -1)",
    "variable": "var(--spacing-surface-3xsmall)"
  },
  "spacing.surface.-xxsmall": {
    "value": "calc(var(--spacing-surface-xxsmall) * -1)",
    "variable": "var(--spacing-surface-xxsmall)"
  },
  "spacing.surface.-xsmall": {
    "value": "calc(var(--spacing-surface-xsmall) * -1)",
    "variable": "var(--spacing-surface-xsmall)"
  },
  "spacing.surface.-small": {
    "value": "calc(var(--spacing-surface-small) * -1)",
    "variable": "var(--spacing-surface-small)"
  },
  "spacing.surface.-medium": {
    "value": "calc(var(--spacing-surface-medium) * -1)",
    "variable": "var(--spacing-surface-medium)"
  },
  "spacing.surface.-large": {
    "value": "calc(var(--spacing-surface-large) * -1)",
    "variable": "var(--spacing-surface-large)"
  },
  "spacing.surface.-xlarge": {
    "value": "calc(var(--spacing-surface-xlarge) * -1)",
    "variable": "var(--spacing-surface-xlarge)"
  },
  "spacing.surface.-xxlarge": {
    "value": "calc(var(--spacing-surface-xxlarge) * -1)",
    "variable": "var(--spacing-surface-xxlarge)"
  },
  "spacing.surface.-3xlarge": {
    "value": "calc(var(--spacing-surface-3xlarge) * -1)",
    "variable": "var(--spacing-surface-3xlarge)"
  },
  "spacing.surface.-4xlarge": {
    "value": "calc(var(--spacing-surface-4xlarge) * -1)",
    "variable": "var(--spacing-surface-4xlarge)"
  },
  "colors.colorPalette.50": {
    "value": "var(--colors-color-palette-50)",
    "variable": "var(--colors-color-palette-50)"
  },
  "colors.colorPalette.100": {
    "value": "var(--colors-color-palette-100)",
    "variable": "var(--colors-color-palette-100)"
  },
  "colors.colorPalette.200": {
    "value": "var(--colors-color-palette-200)",
    "variable": "var(--colors-color-palette-200)"
  },
  "colors.colorPalette.300": {
    "value": "var(--colors-color-palette-300)",
    "variable": "var(--colors-color-palette-300)"
  },
  "colors.colorPalette.400": {
    "value": "var(--colors-color-palette-400)",
    "variable": "var(--colors-color-palette-400)"
  },
  "colors.colorPalette.500": {
    "value": "var(--colors-color-palette-500)",
    "variable": "var(--colors-color-palette-500)"
  },
  "colors.colorPalette.600": {
    "value": "var(--colors-color-palette-600)",
    "variable": "var(--colors-color-palette-600)"
  },
  "colors.colorPalette.700": {
    "value": "var(--colors-color-palette-700)",
    "variable": "var(--colors-color-palette-700)"
  },
  "colors.colorPalette.800": {
    "value": "var(--colors-color-palette-800)",
    "variable": "var(--colors-color-palette-800)"
  },
  "colors.colorPalette.900": {
    "value": "var(--colors-color-palette-900)",
    "variable": "var(--colors-color-palette-900)"
  },
  "colors.colorPalette.950": {
    "value": "var(--colors-color-palette-950)",
    "variable": "var(--colors-color-palette-950)"
  },
  "colors.colorPalette.alpha.5": {
    "value": "var(--colors-color-palette-alpha-5)",
    "variable": "var(--colors-color-palette-alpha-5)"
  },
  "colors.colorPalette.5": {
    "value": "var(--colors-color-palette-5)",
    "variable": "var(--colors-color-palette-5)"
  },
  "colors.colorPalette.alpha.10": {
    "value": "var(--colors-color-palette-alpha-10)",
    "variable": "var(--colors-color-palette-alpha-10)"
  },
  "colors.colorPalette.10": {
    "value": "var(--colors-color-palette-10)",
    "variable": "var(--colors-color-palette-10)"
  },
  "colors.colorPalette.alpha.20": {
    "value": "var(--colors-color-palette-alpha-20)",
    "variable": "var(--colors-color-palette-alpha-20)"
  },
  "colors.colorPalette.20": {
    "value": "var(--colors-color-palette-20)",
    "variable": "var(--colors-color-palette-20)"
  },
  "colors.colorPalette.alpha.30": {
    "value": "var(--colors-color-palette-alpha-30)",
    "variable": "var(--colors-color-palette-alpha-30)"
  },
  "colors.colorPalette.30": {
    "value": "var(--colors-color-palette-30)",
    "variable": "var(--colors-color-palette-30)"
  },
  "colors.colorPalette.alpha.40": {
    "value": "var(--colors-color-palette-alpha-40)",
    "variable": "var(--colors-color-palette-alpha-40)"
  },
  "colors.colorPalette.40": {
    "value": "var(--colors-color-palette-40)",
    "variable": "var(--colors-color-palette-40)"
  },
  "colors.colorPalette.alpha.50": {
    "value": "var(--colors-color-palette-alpha-50)",
    "variable": "var(--colors-color-palette-alpha-50)"
  },
  "colors.colorPalette.alpha.60": {
    "value": "var(--colors-color-palette-alpha-60)",
    "variable": "var(--colors-color-palette-alpha-60)"
  },
  "colors.colorPalette.60": {
    "value": "var(--colors-color-palette-60)",
    "variable": "var(--colors-color-palette-60)"
  },
  "colors.colorPalette.alpha.70": {
    "value": "var(--colors-color-palette-alpha-70)",
    "variable": "var(--colors-color-palette-alpha-70)"
  },
  "colors.colorPalette.70": {
    "value": "var(--colors-color-palette-70)",
    "variable": "var(--colors-color-palette-70)"
  },
  "colors.colorPalette.alpha.80": {
    "value": "var(--colors-color-palette-alpha-80)",
    "variable": "var(--colors-color-palette-alpha-80)"
  },
  "colors.colorPalette.80": {
    "value": "var(--colors-color-palette-80)",
    "variable": "var(--colors-color-palette-80)"
  },
  "colors.colorPalette.alpha.90": {
    "value": "var(--colors-color-palette-alpha-90)",
    "variable": "var(--colors-color-palette-alpha-90)"
  },
  "colors.colorPalette.90": {
    "value": "var(--colors-color-palette-90)",
    "variable": "var(--colors-color-palette-90)"
  },
  "colors.colorPalette.1000": {
    "value": "var(--colors-color-palette-1000)",
    "variable": "var(--colors-color-palette-1000)"
  },
  "colors.colorPalette.1100": {
    "value": "var(--colors-color-palette-1100)",
    "variable": "var(--colors-color-palette-1100)"
  },
  "colors.colorPalette.1200": {
    "value": "var(--colors-color-palette-1200)",
    "variable": "var(--colors-color-palette-1200)"
  },
  "colors.colorPalette.1300": {
    "value": "var(--colors-color-palette-1300)",
    "variable": "var(--colors-color-palette-1300)"
  },
  "colors.colorPalette.1400": {
    "value": "var(--colors-color-palette-1400)",
    "variable": "var(--colors-color-palette-1400)"
  },
  "colors.colorPalette": {
    "value": "var(--colors-color-palette)",
    "variable": "var(--colors-color-palette)"
  },
  "colors.colorPalette.default": {
    "value": "var(--colors-color-palette-default)",
    "variable": "var(--colors-color-palette-default)"
  },
  "colors.colorPalette.subtle": {
    "value": "var(--colors-color-palette-subtle)",
    "variable": "var(--colors-color-palette-subtle)"
  },
  "colors.colorPalette.strong": {
    "value": "var(--colors-color-palette-strong)",
    "variable": "var(--colors-color-palette-strong)"
  },
  "colors.colorPalette.action": {
    "value": "var(--colors-color-palette-action)",
    "variable": "var(--colors-color-palette-action)"
  },
  "colors.colorPalette.onAction": {
    "value": "var(--colors-color-palette-on-action)",
    "variable": "var(--colors-color-palette-on-action)"
  },
  "colors.colorPalette.link": {
    "value": "var(--colors-color-palette-link)",
    "variable": "var(--colors-color-palette-link)"
  },
  "colors.colorPalette.linkVisited": {
    "value": "var(--colors-color-palette-link-visited)",
    "variable": "var(--colors-color-palette-link-visited)"
  },
  "colors.colorPalette.error": {
    "value": "var(--colors-color-palette-error)",
    "variable": "var(--colors-color-palette-error)"
  },
  "colors.colorPalette.disabled": {
    "value": "var(--colors-color-palette-disabled)",
    "variable": "var(--colors-color-palette-disabled)"
  },
  "colors.colorPalette.warning": {
    "value": "var(--colors-color-palette-warning)",
    "variable": "var(--colors-color-palette-warning)"
  },
  "colors.colorPalette.danger": {
    "value": "var(--colors-color-palette-danger)",
    "variable": "var(--colors-color-palette-danger)"
  },
  "colors.colorPalette.brand.1": {
    "value": "var(--colors-color-palette-brand-1)",
    "variable": "var(--colors-color-palette-brand-1)"
  },
  "colors.colorPalette.1": {
    "value": "var(--colors-color-palette-1)",
    "variable": "var(--colors-color-palette-1)"
  },
  "colors.colorPalette.brand.1.subtle": {
    "value": "var(--colors-color-palette-brand-1-subtle)",
    "variable": "var(--colors-color-palette-brand-1-subtle)"
  },
  "colors.colorPalette.1.subtle": {
    "value": "var(--colors-color-palette-1-subtle)",
    "variable": "var(--colors-color-palette-1-subtle)"
  },
  "colors.colorPalette.brand.1.moderate": {
    "value": "var(--colors-color-palette-brand-1-moderate)",
    "variable": "var(--colors-color-palette-brand-1-moderate)"
  },
  "colors.colorPalette.1.moderate": {
    "value": "var(--colors-color-palette-1-moderate)",
    "variable": "var(--colors-color-palette-1-moderate)"
  },
  "colors.colorPalette.moderate": {
    "value": "var(--colors-color-palette-moderate)",
    "variable": "var(--colors-color-palette-moderate)"
  },
  "colors.colorPalette.brand.1.strong": {
    "value": "var(--colors-color-palette-brand-1-strong)",
    "variable": "var(--colors-color-palette-brand-1-strong)"
  },
  "colors.colorPalette.1.strong": {
    "value": "var(--colors-color-palette-1-strong)",
    "variable": "var(--colors-color-palette-1-strong)"
  },
  "colors.colorPalette.brand.2": {
    "value": "var(--colors-color-palette-brand-2)",
    "variable": "var(--colors-color-palette-brand-2)"
  },
  "colors.colorPalette.2": {
    "value": "var(--colors-color-palette-2)",
    "variable": "var(--colors-color-palette-2)"
  },
  "colors.colorPalette.brand.2.subtle": {
    "value": "var(--colors-color-palette-brand-2-subtle)",
    "variable": "var(--colors-color-palette-brand-2-subtle)"
  },
  "colors.colorPalette.2.subtle": {
    "value": "var(--colors-color-palette-2-subtle)",
    "variable": "var(--colors-color-palette-2-subtle)"
  },
  "colors.colorPalette.brand.2.moderate": {
    "value": "var(--colors-color-palette-brand-2-moderate)",
    "variable": "var(--colors-color-palette-brand-2-moderate)"
  },
  "colors.colorPalette.2.moderate": {
    "value": "var(--colors-color-palette-2-moderate)",
    "variable": "var(--colors-color-palette-2-moderate)"
  },
  "colors.colorPalette.brand.2.bold": {
    "value": "var(--colors-color-palette-brand-2-bold)",
    "variable": "var(--colors-color-palette-brand-2-bold)"
  },
  "colors.colorPalette.2.bold": {
    "value": "var(--colors-color-palette-2-bold)",
    "variable": "var(--colors-color-palette-2-bold)"
  },
  "colors.colorPalette.bold": {
    "value": "var(--colors-color-palette-bold)",
    "variable": "var(--colors-color-palette-bold)"
  },
  "colors.colorPalette.brand.2.strong": {
    "value": "var(--colors-color-palette-brand-2-strong)",
    "variable": "var(--colors-color-palette-brand-2-strong)"
  },
  "colors.colorPalette.2.strong": {
    "value": "var(--colors-color-palette-2-strong)",
    "variable": "var(--colors-color-palette-2-strong)"
  },
  "colors.colorPalette.brand.3": {
    "value": "var(--colors-color-palette-brand-3)",
    "variable": "var(--colors-color-palette-brand-3)"
  },
  "colors.colorPalette.3": {
    "value": "var(--colors-color-palette-3)",
    "variable": "var(--colors-color-palette-3)"
  },
  "colors.colorPalette.brand.3.subtle": {
    "value": "var(--colors-color-palette-brand-3-subtle)",
    "variable": "var(--colors-color-palette-brand-3-subtle)"
  },
  "colors.colorPalette.3.subtle": {
    "value": "var(--colors-color-palette-3-subtle)",
    "variable": "var(--colors-color-palette-3-subtle)"
  },
  "colors.colorPalette.brand.3.moderate": {
    "value": "var(--colors-color-palette-brand-3-moderate)",
    "variable": "var(--colors-color-palette-brand-3-moderate)"
  },
  "colors.colorPalette.3.moderate": {
    "value": "var(--colors-color-palette-3-moderate)",
    "variable": "var(--colors-color-palette-3-moderate)"
  },
  "colors.colorPalette.brand.3.strong": {
    "value": "var(--colors-color-palette-brand-3-strong)",
    "variable": "var(--colors-color-palette-brand-3-strong)"
  },
  "colors.colorPalette.3.strong": {
    "value": "var(--colors-color-palette-3-strong)",
    "variable": "var(--colors-color-palette-3-strong)"
  },
  "colors.colorPalette.brand.4": {
    "value": "var(--colors-color-palette-brand-4)",
    "variable": "var(--colors-color-palette-brand-4)"
  },
  "colors.colorPalette.4": {
    "value": "var(--colors-color-palette-4)",
    "variable": "var(--colors-color-palette-4)"
  },
  "colors.colorPalette.brand.4.subtle": {
    "value": "var(--colors-color-palette-brand-4-subtle)",
    "variable": "var(--colors-color-palette-brand-4-subtle)"
  },
  "colors.colorPalette.4.subtle": {
    "value": "var(--colors-color-palette-4-subtle)",
    "variable": "var(--colors-color-palette-4-subtle)"
  },
  "colors.colorPalette.brand.4.moderate": {
    "value": "var(--colors-color-palette-brand-4-moderate)",
    "variable": "var(--colors-color-palette-brand-4-moderate)"
  },
  "colors.colorPalette.4.moderate": {
    "value": "var(--colors-color-palette-4-moderate)",
    "variable": "var(--colors-color-palette-4-moderate)"
  },
  "colors.colorPalette.brand.4.strong": {
    "value": "var(--colors-color-palette-brand-4-strong)",
    "variable": "var(--colors-color-palette-brand-4-strong)"
  },
  "colors.colorPalette.4.strong": {
    "value": "var(--colors-color-palette-4-strong)",
    "variable": "var(--colors-color-palette-4-strong)"
  },
  "colors.colorPalette.brand.5": {
    "value": "var(--colors-color-palette-brand-5)",
    "variable": "var(--colors-color-palette-brand-5)"
  },
  "colors.colorPalette.brand.5.subtle": {
    "value": "var(--colors-color-palette-brand-5-subtle)",
    "variable": "var(--colors-color-palette-brand-5-subtle)"
  },
  "colors.colorPalette.5.subtle": {
    "value": "var(--colors-color-palette-5-subtle)",
    "variable": "var(--colors-color-palette-5-subtle)"
  },
  "colors.colorPalette.brand.5.moderate": {
    "value": "var(--colors-color-palette-brand-5-moderate)",
    "variable": "var(--colors-color-palette-brand-5-moderate)"
  },
  "colors.colorPalette.5.moderate": {
    "value": "var(--colors-color-palette-5-moderate)",
    "variable": "var(--colors-color-palette-5-moderate)"
  },
  "colors.colorPalette.brand.5.strong": {
    "value": "var(--colors-color-palette-brand-5-strong)",
    "variable": "var(--colors-color-palette-brand-5-strong)"
  },
  "colors.colorPalette.5.strong": {
    "value": "var(--colors-color-palette-5-strong)",
    "variable": "var(--colors-color-palette-5-strong)"
  },
  "colors.colorPalette.hover": {
    "value": "var(--colors-color-palette-hover)",
    "variable": "var(--colors-color-palette-hover)"
  },
  "colors.colorPalette.active": {
    "value": "var(--colors-color-palette-active)",
    "variable": "var(--colors-color-palette-active)"
  },
  "colors.colorPalette.selected": {
    "value": "var(--colors-color-palette-selected)",
    "variable": "var(--colors-color-palette-selected)"
  },
  "colors.colorPalette.disabled.subtle": {
    "value": "var(--colors-color-palette-disabled-subtle)",
    "variable": "var(--colors-color-palette-disabled-subtle)"
  },
  "colors.colorPalette.disabled.strong": {
    "value": "var(--colors-color-palette-disabled-strong)",
    "variable": "var(--colors-color-palette-disabled-strong)"
  },
  "colors.colorPalette.infoSubtle": {
    "value": "var(--colors-color-palette-info-subtle)",
    "variable": "var(--colors-color-palette-info-subtle)"
  },
  "colors.colorPalette.infoSubtle.hover": {
    "value": "var(--colors-color-palette-info-subtle-hover)",
    "variable": "var(--colors-color-palette-info-subtle-hover)"
  },
  "colors.colorPalette.infoSubtle.active": {
    "value": "var(--colors-color-palette-info-subtle-active)",
    "variable": "var(--colors-color-palette-info-subtle-active)"
  },
  "colors.colorPalette.action.hover": {
    "value": "var(--colors-color-palette-action-hover)",
    "variable": "var(--colors-color-palette-action-hover)"
  },
  "colors.colorPalette.action.active": {
    "value": "var(--colors-color-palette-action-active)",
    "variable": "var(--colors-color-palette-action-active)"
  },
  "colors.colorPalette.action.selected": {
    "value": "var(--colors-color-palette-action-selected)",
    "variable": "var(--colors-color-palette-action-selected)"
  },
  "colors.colorPalette.action.myNdla": {
    "value": "var(--colors-color-palette-action-my-ndla)",
    "variable": "var(--colors-color-palette-action-my-ndla)"
  },
  "colors.colorPalette.myNdla": {
    "value": "var(--colors-color-palette-my-ndla)",
    "variable": "var(--colors-color-palette-my-ndla)"
  },
  "colors.colorPalette.action.myNdla.hover": {
    "value": "var(--colors-color-palette-action-my-ndla-hover)",
    "variable": "var(--colors-color-palette-action-my-ndla-hover)"
  },
  "colors.colorPalette.myNdla.hover": {
    "value": "var(--colors-color-palette-my-ndla-hover)",
    "variable": "var(--colors-color-palette-my-ndla-hover)"
  },
  "colors.colorPalette.action.myNdla.current": {
    "value": "var(--colors-color-palette-action-my-ndla-current)",
    "variable": "var(--colors-color-palette-action-my-ndla-current)"
  },
  "colors.colorPalette.myNdla.current": {
    "value": "var(--colors-color-palette-my-ndla-current)",
    "variable": "var(--colors-color-palette-my-ndla-current)"
  },
  "colors.colorPalette.current": {
    "value": "var(--colors-color-palette-current)",
    "variable": "var(--colors-color-palette-current)"
  },
  "colors.colorPalette.action.brand.1": {
    "value": "var(--colors-color-palette-action-brand-1)",
    "variable": "var(--colors-color-palette-action-brand-1)"
  },
  "colors.colorPalette.action.brand.1.hover": {
    "value": "var(--colors-color-palette-action-brand-1-hover)",
    "variable": "var(--colors-color-palette-action-brand-1-hover)"
  },
  "colors.colorPalette.brand.1.hover": {
    "value": "var(--colors-color-palette-brand-1-hover)",
    "variable": "var(--colors-color-palette-brand-1-hover)"
  },
  "colors.colorPalette.1.hover": {
    "value": "var(--colors-color-palette-1-hover)",
    "variable": "var(--colors-color-palette-1-hover)"
  },
  "colors.colorPalette.action.brand.1.hover.strong": {
    "value": "var(--colors-color-palette-action-brand-1-hover-strong)",
    "variable": "var(--colors-color-palette-action-brand-1-hover-strong)"
  },
  "colors.colorPalette.brand.1.hover.strong": {
    "value": "var(--colors-color-palette-brand-1-hover-strong)",
    "variable": "var(--colors-color-palette-brand-1-hover-strong)"
  },
  "colors.colorPalette.1.hover.strong": {
    "value": "var(--colors-color-palette-1-hover-strong)",
    "variable": "var(--colors-color-palette-1-hover-strong)"
  },
  "colors.colorPalette.hover.strong": {
    "value": "var(--colors-color-palette-hover-strong)",
    "variable": "var(--colors-color-palette-hover-strong)"
  },
  "colors.colorPalette.action.brand.1.active": {
    "value": "var(--colors-color-palette-action-brand-1-active)",
    "variable": "var(--colors-color-palette-action-brand-1-active)"
  },
  "colors.colorPalette.brand.1.active": {
    "value": "var(--colors-color-palette-brand-1-active)",
    "variable": "var(--colors-color-palette-brand-1-active)"
  },
  "colors.colorPalette.1.active": {
    "value": "var(--colors-color-palette-1-active)",
    "variable": "var(--colors-color-palette-1-active)"
  },
  "colors.colorPalette.action.brand.1.selected": {
    "value": "var(--colors-color-palette-action-brand-1-selected)",
    "variable": "var(--colors-color-palette-action-brand-1-selected)"
  },
  "colors.colorPalette.brand.1.selected": {
    "value": "var(--colors-color-palette-brand-1-selected)",
    "variable": "var(--colors-color-palette-brand-1-selected)"
  },
  "colors.colorPalette.1.selected": {
    "value": "var(--colors-color-palette-1-selected)",
    "variable": "var(--colors-color-palette-1-selected)"
  },
  "colors.colorPalette.action.brand.2": {
    "value": "var(--colors-color-palette-action-brand-2)",
    "variable": "var(--colors-color-palette-action-brand-2)"
  },
  "colors.colorPalette.action.brand.2.hover": {
    "value": "var(--colors-color-palette-action-brand-2-hover)",
    "variable": "var(--colors-color-palette-action-brand-2-hover)"
  },
  "colors.colorPalette.brand.2.hover": {
    "value": "var(--colors-color-palette-brand-2-hover)",
    "variable": "var(--colors-color-palette-brand-2-hover)"
  },
  "colors.colorPalette.2.hover": {
    "value": "var(--colors-color-palette-2-hover)",
    "variable": "var(--colors-color-palette-2-hover)"
  },
  "colors.colorPalette.action.brand.2.selected": {
    "value": "var(--colors-color-palette-action-brand-2-selected)",
    "variable": "var(--colors-color-palette-action-brand-2-selected)"
  },
  "colors.colorPalette.brand.2.selected": {
    "value": "var(--colors-color-palette-brand-2-selected)",
    "variable": "var(--colors-color-palette-brand-2-selected)"
  },
  "colors.colorPalette.2.selected": {
    "value": "var(--colors-color-palette-2-selected)",
    "variable": "var(--colors-color-palette-2-selected)"
  },
  "colors.colorPalette.actionSubtle": {
    "value": "var(--colors-color-palette-action-subtle)",
    "variable": "var(--colors-color-palette-action-subtle)"
  },
  "colors.colorPalette.actionSubtle.hover": {
    "value": "var(--colors-color-palette-action-subtle-hover)",
    "variable": "var(--colors-color-palette-action-subtle-hover)"
  },
  "colors.colorPalette.actionSubtle.hover.strong": {
    "value": "var(--colors-color-palette-action-subtle-hover-strong)",
    "variable": "var(--colors-color-palette-action-subtle-hover-strong)"
  },
  "colors.colorPalette.actionSubtle.active": {
    "value": "var(--colors-color-palette-action-subtle-active)",
    "variable": "var(--colors-color-palette-action-subtle-active)"
  },
  "colors.colorPalette.actionSubtle.selected": {
    "value": "var(--colors-color-palette-action-subtle-selected)",
    "variable": "var(--colors-color-palette-action-subtle-selected)"
  },
  "colors.colorPalette.success": {
    "value": "var(--colors-color-palette-success)",
    "variable": "var(--colors-color-palette-success)"
  },
  "colors.colorPalette.success.hover": {
    "value": "var(--colors-color-palette-success-hover)",
    "variable": "var(--colors-color-palette-success-hover)"
  },
  "colors.colorPalette.success.selected": {
    "value": "var(--colors-color-palette-success-selected)",
    "variable": "var(--colors-color-palette-success-selected)"
  },
  "colors.colorPalette.success.active": {
    "value": "var(--colors-color-palette-success-active)",
    "variable": "var(--colors-color-palette-success-active)"
  },
  "colors.colorPalette.successSubtle": {
    "value": "var(--colors-color-palette-success-subtle)",
    "variable": "var(--colors-color-palette-success-subtle)"
  },
  "colors.colorPalette.successSubtle.hover": {
    "value": "var(--colors-color-palette-success-subtle-hover)",
    "variable": "var(--colors-color-palette-success-subtle-hover)"
  },
  "colors.colorPalette.successSubtle.active": {
    "value": "var(--colors-color-palette-success-subtle-active)",
    "variable": "var(--colors-color-palette-success-subtle-active)"
  },
  "colors.colorPalette.warning.hover": {
    "value": "var(--colors-color-palette-warning-hover)",
    "variable": "var(--colors-color-palette-warning-hover)"
  },
  "colors.colorPalette.warning.active": {
    "value": "var(--colors-color-palette-warning-active)",
    "variable": "var(--colors-color-palette-warning-active)"
  },
  "colors.colorPalette.warningSubtle": {
    "value": "var(--colors-color-palette-warning-subtle)",
    "variable": "var(--colors-color-palette-warning-subtle)"
  },
  "colors.colorPalette.warningSubtle.hover": {
    "value": "var(--colors-color-palette-warning-subtle-hover)",
    "variable": "var(--colors-color-palette-warning-subtle-hover)"
  },
  "colors.colorPalette.warningSubtle.active": {
    "value": "var(--colors-color-palette-warning-subtle-active)",
    "variable": "var(--colors-color-palette-warning-subtle-active)"
  },
  "colors.colorPalette.danger.hover": {
    "value": "var(--colors-color-palette-danger-hover)",
    "variable": "var(--colors-color-palette-danger-hover)"
  },
  "colors.colorPalette.danger.selected": {
    "value": "var(--colors-color-palette-danger-selected)",
    "variable": "var(--colors-color-palette-danger-selected)"
  },
  "colors.colorPalette.danger.active": {
    "value": "var(--colors-color-palette-danger-active)",
    "variable": "var(--colors-color-palette-danger-active)"
  },
  "colors.colorPalette.dangerSubtle": {
    "value": "var(--colors-color-palette-danger-subtle)",
    "variable": "var(--colors-color-palette-danger-subtle)"
  },
  "colors.colorPalette.dangerSubtle.hover": {
    "value": "var(--colors-color-palette-danger-subtle-hover)",
    "variable": "var(--colors-color-palette-danger-subtle-hover)"
  },
  "colors.colorPalette.dangerSubtle.active": {
    "value": "var(--colors-color-palette-danger-subtle-active)",
    "variable": "var(--colors-color-palette-danger-subtle-active)"
  },
  "colors.colorPalette.error.hover": {
    "value": "var(--colors-color-palette-error-hover)",
    "variable": "var(--colors-color-palette-error-hover)"
  },
  "colors.colorPalette.error.active": {
    "value": "var(--colors-color-palette-error-active)",
    "variable": "var(--colors-color-palette-error-active)"
  },
  "colors.colorPalette.errorSubtle": {
    "value": "var(--colors-color-palette-error-subtle)",
    "variable": "var(--colors-color-palette-error-subtle)"
  },
  "colors.colorPalette.errorSubtle.hover": {
    "value": "var(--colors-color-palette-error-subtle-hover)",
    "variable": "var(--colors-color-palette-error-subtle-hover)"
  },
  "colors.colorPalette.errorSubtle.active": {
    "value": "var(--colors-color-palette-error-subtle-active)",
    "variable": "var(--colors-color-palette-error-subtle-active)"
  },
  "colors.colorPalette.subtle.selected": {
    "value": "var(--colors-color-palette-subtle-selected)",
    "variable": "var(--colors-color-palette-subtle-selected)"
  },
  "colors.colorPalette.info": {
    "value": "var(--colors-color-palette-info)",
    "variable": "var(--colors-color-palette-info)"
  },
  "colors.colorPalette.discrete": {
    "value": "var(--colors-color-palette-discrete)",
    "variable": "var(--colors-color-palette-discrete)"
  }
}

export function token(path, fallback) {
  return tokens[path]?.value || fallback
}

function tokenVar(path, fallback) {
  return tokens[path]?.variable || fallback
}

token.var = tokenVar